import { Brands } from './brands';

// Import assets for unknown brand
import unknownHero from '@shared/assets/brands/none/blank-hero.jpg';
import unknownLogo from '@shared/assets/brands/none/blank-logo.png';

// Import assets for AIT brand
import aitHero from '@shared/assets/brands/ait/ait-hero.jpg';
import aitLogo from '@shared/assets/brands/ait/ait-logo.svg';

// Import assets for HOIAX brand
import hoiaxHero from '@shared/assets/brands/hoiax/hoiax-hero.jpg';
import hoiaxLogo from '@shared/assets/brands/hoiax/hoiax-logo.svg';

// Import assets for IEC brand
import iecHero from '@shared/assets/brands/iec/iec-hero.jpg';
import iecLogo from '@shared/assets/brands/iec/iec-logo.svg';

// Import assets for Jama brand
import jamaHero from '@shared/assets/brands/jama/jama-hero.jpg';
import jamaLogo from '@shared/assets/brands/jama/jama-logo.svg';

// Import assets for Jaspi brand
import jaspiHero from '@shared/assets/brands/jaspi/jaspi-hero.jpg';
import jaspiLogo from '@shared/assets/brands/jaspi/jaspi-logo.svg';

// Import assets for Metrotherm brand
import metrothermHero from '@shared/assets/brands/metrotherm/metrotherm-hero.jpg';
import metrothermLogo from '@shared/assets/brands/metrotherm/metrotherm-logo.svg';

// Import assets for MHI brand
import mhiHero from '@shared/assets/brands/mhi/mhi-hero.jpg';
import mhiLogo from '@shared/assets/brands/mhi/mhi-logo.svg';

// Import assets for NIBE brand
import nibeHero from '@shared/assets/brands/nibe/nibe-hero.jpg';
import nibeLogo from '@shared/assets/brands/nibe/nibe-logo.svg';

// Import assets for NIBEF brand
import nibefHero from '@shared/assets/brands/nibef/nibef-hero.jpg';
import nibefLogo from '@shared/assets/brands/nibef/nibef-logo.svg';

// Import assets for TIKI brand
import tikiHero from '@shared/assets/brands/tiki/tiki-hero.jpg';
import tikiLogo from '@shared/assets/brands/tiki/tiki-logo.svg';

// Import assets for TEMPEFF brand
import tempeffHero from '@shared/assets/brands/tempeff/tempeff-hero.jpg';
import tempeffLogo from '@shared/assets/brands/tempeff/tempeff-logo.svg';

// Import assets for AIRSITE brand
import airsiteHero from '@shared/assets/brands/airsite/airsite-hero.jpg';
import airsiteLogo from '@shared/assets/brands/airsite/airsite-logo.svg';

// Import assets for BIAWAR brand
import biawarHero from '@shared/assets/brands/biawar/biawar-hero.jpg';
import biawarLogo from '@shared/assets/brands/biawar/biawar-logo.svg';

// Import assets for CETETHERM brand
import cetethermHero from '@shared/assets/brands/cetetherm/cetetherm-hero.jpg';
import cetethermLogo from '@shared/assets/brands/cetetherm/cetetherm-logo.svg';

// Import assets for CLIMATEMASTER brand
import climatemasterHero from '@shared/assets/brands/climatemaster/climatemaster-hero.jpg';
import climatemasterLogo from '@shared/assets/brands/climatemaster/climatemaster-logo.svg';

// Import assets for CONTURA brand
import conturaHero from '@shared/assets/brands/contura/contura-hero.jpg';
import conturaLogo from '@shared/assets/brands/contura/contura-logo.svg';

// Import assets for CTA brand
import ctaHero from '@shared/assets/brands/cta/cta-hero.jpg';
import ctaLogo from '@shared/assets/brands/cta/cta-logo.svg';

// Import assets for CTC brand
import ctcHero from '@shared/assets/brands/ctc/ctc-hero.jpg';
import ctcLogo from '@shared/assets/brands/ctc/ctc-logo.svg';

// Import assets for DZD brand
import dzdHero from '@shared/assets/brands/dzd/dzd-hero.jpg';
import dzdLogo from '@shared/assets/brands/dzd/dzd-logo.svg';

// Import assets for DANDELION brand
import dandelionHero from '@shared/assets/brands/dandelion/dandelion-hero.jpg';
import dandelionLogo from '@shared/assets/brands/dandelion/dandelion-logo.svg';

// Import assets for ENERTECH brand
import enertechHero from '@shared/assets/brands/enertech/enertech-hero.jpg';
import enertechLogo from '@shared/assets/brands/enertech/enertech-logo.svg';

// Import assets for MYUPLINK brand
import myuplinkHero from '@shared/assets/brands/myuplink/myuplink-hero.jpg';
import myuplinkLogo from '@shared/assets/brands/myuplink/myuplink-logo.png';

// Import assets for NOVELAN brand
import novelanHero from '@shared/assets/brands/novelan/novelan-hero.jpg';
import novelanLogo from '@shared/assets/brands/novelan/novelan-logo.svg';

// Import assets for ROTH brand
import rothHero from '@shared/assets/brands/roth/roth-hero.jpg';
import rothLogo from '@shared/assets/brands/roth/roth-logo.svg';

const brandsAssets = {
  unknown: { logo: unknownLogo, hero: unknownHero },
  [Brands.AIRSITE]: { logo: airsiteLogo, hero: airsiteHero },
  [Brands.AIT]: { logo: aitLogo, hero: aitHero },
  [Brands.BIAWAR]: { logo: biawarLogo, hero: biawarHero },
  [Brands.CETETHERM]: { logo: cetethermLogo, hero: cetethermHero },
  [Brands.CLIMATEMASTER]: { logo: climatemasterLogo, hero: climatemasterHero },
  [Brands.CONTURA]: { logo: conturaLogo, hero: conturaHero },
  [Brands.CTA]: { logo: ctaLogo, hero: ctaHero },
  [Brands.CTC]: { logo: ctcLogo, hero: ctcHero },
  [Brands.DZD]: { logo: dzdLogo, hero: dzdHero },
  [Brands.DANDELION]: { logo: dandelionLogo, hero: dandelionHero },
  [Brands.ENERTECH]: { logo: enertechLogo, hero: enertechHero },
  [Brands.HOIAX]: { logo: hoiaxLogo, hero: hoiaxHero },
  [Brands.IEC]: { logo: iecLogo, hero: iecHero },
  [Brands.JAMA]: { logo: jamaLogo, hero: jamaHero },
  [Brands.JASPI]: { logo: jaspiLogo, hero: jaspiHero },
  [Brands.METROTHERM]: { logo: metrothermLogo, hero: metrothermHero },
  [Brands.MHI]: { logo: mhiLogo, hero: mhiHero },
  [Brands.MYUPLINK]: { logo: myuplinkLogo, hero: myuplinkHero },
  [Brands.NIBE]: { logo: nibeLogo, hero: nibeHero },
  [Brands.NIBEF]: { logo: nibefLogo, hero: nibefHero },
  [Brands.NOVELAN]: { logo: novelanLogo, hero: novelanHero },
  [Brands.ROTH]: { logo: rothLogo, hero: rothHero },
  [Brands.TEMPEFF]: { logo: tempeffLogo, hero: tempeffHero },
  [Brands.TIKI]: { logo: tikiLogo, hero: tikiHero },
};

export { brandsAssets };
export default brandsAssets;
